import { authRoutes } from "@/utils/constant";
import axios from "axios";
import cookie from 'js-cookie';

const API_BASE_URL = import.meta.env.VITE_API_URL
  ? `${import.meta.env.VITE_API_URL}/api/v2`
  : "/api/v2";

export const Api = axios.create({
  baseURL: API_BASE_URL
});

Api.interceptors.request.use(
  (config) => {
    const token = cookie.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      cookie.remove('token');
      if (!authRoutes.includes(window.location.pathname)) {
        window.location.href = '/auth/login';
      }
    }
    return Promise.reject(error);
  }
);